<template>
    <li class="nav-link-back">
        <span class="sub-menu-back-button menu-link"
              tabindex="0"
              v-on:click="handleBackButtonInteraction($event, item)"
              v-on:keydown="handleBackButtonInteraction($event, item)">
            <span class="sub-menu-back-button-label">Back</span>
        </span>
    </li>
</template>

<script>

export default {
    data() {
        return {};
    },
    props: {
        item: {
            type:    Object,
            default: {}
        },
    },

    computed: {},

    mounted() {
        // console.log('SubMenuBackButton.vue mounted');
    },
    methods: {
        handleBackButtonInteraction(e, item) {

            if (this.$parent.mobileMenuActive) {

                if (e.type === "click") {
                    // console.log('clicking back button')
                    // console.log(e.target)
                    e.target.closest('.expanded').classList.remove('expanded');
                } else if (e.type === "keydown") {
                    if (e.key === 'Enter' || (e.key === 'Tab' && e.shiftKey)) {
                        e.preventDefault();
                        let activeSubMenuParentMenuItem = e.target.closest('.expanded');
                        activeSubMenuParentMenuItem.classList.remove('expanded');
                        activeSubMenuParentMenuItem.querySelector('a').focus();
                    }
                }
            }
        }
    }
}

</script>